import React, { Component } from 'react'
import styled from 'styled-components'
import easing from 'ui/styles/easing'
import theme from 'ui/styles/theme'

const Icon = styled.svg`
  linearGradient stop {
    transition: stop-color 0.3s ${easing.easeOutCubic};
  }

  path {
    transition: stroke 0.3s ${easing.easeOutCubic};
  }
`

export default class IconCircledArrow extends Component {
  static defaultProps = {
    look: null
  }
  
  render() {
    const {
      hover,
      look
    } = this.props
    
    const defaultColor = look === 'orange' ? theme.colors.tones.lightest : theme.colors.tones.darker
    const hoverColor = 'white'

    return(
      <Icon
        width="62"
        height="38"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          transform="rotate(-90 18.5 19)"
          fill="none"
          fillRule="evenodd"
          opacity="1"
        >
          <path
            d="M24.79 43.2879516l-6.28982732 6.2224096L12.21 43.2879516M18.5 49.5447675V.74698772"
            stroke={hover ? hoverColor : defaultColor}
          />
        </g>
      </Icon>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/generic/IconCircledArrow.js